/**
 * Returns the power term of a floating point.
 *
 * e.g.:
 * The number 123.45 can be represented as a decimal floating-point number
 * with the integer 12345 as the significand and a 10−2 power term
 *
 * @param {number} value The value to get the power term form
 * @return The number's power term
 */
function getPowerTerm(value: number): number {
  return (value.toString().split(".")[1] || "").length;
}

function getMaxPowerTerm(...numbers: number[]): number {
  const scaleFactors = numbers.map((num) => getPowerTerm(num));
  return Math.max(...scaleFactors);
}

export function getPreciseSubtraction(firstNumber: number, ...numbers: number[]): number {
  // Find the maximum number of decimal places in the input numbers
  const scaleFactor = 10 ** getMaxPowerTerm(firstNumber, ...numbers);
  // Scale all numbers to integers and sub them
  const scaledSub = numbers.reduce((sub, num) => sub - Math.round(num * scaleFactor), firstNumber * scaleFactor);

  // Scale the sum back to the original scale
  return scaledSub / scaleFactor;
}
